import { Box, Typography } from "@mui/material";
import pagenotfound from "../../images/page_not_found_404.gif";

const PageNotFound = () => {
  return (
    <>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundImage: `url(${pagenotfound})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          zIndex: -1,
        }}
      />
      <Box
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "80vh",
          textAlign: "center",
          gap: "20px",
          color: "#fff",
        }}
      >
        <Typography variant="h5">Oops! You lost into Space!</Typography>
        <Typography variant="body1">
          The page you are looking for does not exist. Please contact the
          Administator.
        </Typography>
      </Box>
    </>
  );
};

export default PageNotFound;
